<template>
    <b-modal
    class="fixedModal"
    ref="myModal"
    size="lg"
    id="modal1"
    :title="title"
    centered
    :hide-footer="true"
    :no-close-on-backdrop="true"
    @hidden="onHidden">
        <div class="scroll">
            <!-- <div v-for="notification in notifications" v-bind:key="notification.id">
                <h3>{{notification.id_notificacion.titulo}}</h3>
                {{notification.id_notificacion.mensaje}}
            </div> -->
            <div v-if="notifications.length==0">
              No tienes ninguna notificación.
            </div>
            <b-card v-for="notification in notifications"
            v-bind:key="notification.id"
            :class="notification.leido ? '':'alert-info'">
                <b-card-title v-html="notification.id_notificacion.titulo">
                </b-card-title>
                <p v-html="notification.id_notificacion.mensaje"></p>
                <b-row v-if="!alert" class="top-buttons">
                    <b-col style="text-align: right;">
                      <b-button v-if="notification.leido" variant="primary" @click="noLeido(notification)">Marcar como no leído</b-button>
                      <b-button v-else variant="primary" @click="leido(notification)">Marcar como leído</b-button>
                      <b-button variant="primary" @click="eliminar(notification)">Eliminar</b-button>
                    </b-col>
                </b-row>
            </b-card>
        </div>
    </b-modal>
</template>

<style>
.top-buttons{
  position: absolute;
  top: 1rem;
  right: 1rem;
}
</style>

<script>
export default {
  name: 'Notifications',
  props: ['notifications', 'alert'],
  data () {
    return {
    };
  },
  mounted: function () {
    this.$refs.myModal.show();
  },
  computed: {
    title: function () {
      if (this.alert) {
        return 'Alertas';
      } else {
        return 'Notificaciones';
      }
    }
  },
  methods: {
    leido: function (n) {
      n.leido = true;
      this.$http.put('notificaciones/' + n.id + '/', n);
    },
    noLeido: function (n) {
      n.leido = false;
      this.$http.put('notificaciones/' + n.id + '/', n);
    },
    eliminar: function (n) {
      this.$parent.deleteNotification(n, this.alert);
    },
    onHidden: function () {
      if (this.alert) {
        this.$parent.hideAlerts();
      } else {
        this.$parent.showNotifications = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/Notifications.vue